import React, { useEffect, useState } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { json } from "@codemirror/lang-json";
import { materialDark } from "@uiw/codemirror-theme-material";
import "./casette.css";
import { updateThemeCasette } from "services/apiService";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
const CasetteUpload = () => {
    const navigate = useNavigate();
  const [code, setCode] = useState(``);
  const [output, setOutput] = useState(
    "// JSON validation result will appear here"
  );
  const [jsonData, setJsonData] = useState(
  ""
  );
  const [isValid, setIsValid] = useState(false);

  const validateJSON = () => {
    try {
      const parsed = JSON.parse(code);
      setOutput(
        "✅ Running Successfully:\n\n" + JSON.stringify(parsed, null, 2)
      );
      setJsonData(JSON.stringify(parsed, null, 2))
      setIsValid(true);
    } catch (err) {
      setOutput("❌ Invalid JSON:\n\n" + err.message);
      setIsValid(false);
    }
  };
  async function handleSubmit() {
    let payload: any = {
        id:1,
      data : jsonData
    };
    try {
      const response = await updateThemeCasette(payload);

      if (response.status_code === 200) {
        toast.success("Casette created successfully!");
        navigate("/dashboard")
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.data?.error);
    }
  }
  let didShowConfirmations = false; 

  useEffect(() => {
    if (didShowConfirmations) return; 
  
    didShowConfirmations = true; 
  
    const showInitialConfirmations = async () => {
      const firstConfirmation = await Swal.fire({
        title: "Are you a developer?",
        text: "This action is only for developers.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, I am Asok 👨‍💻",
        cancelButtonText: "Cancel",
      });
  
      if (firstConfirmation.isConfirmed) {
        const secondConfirmation = await Swal.fire({
          title: "Are you really sure?",
          text: "This action cannot be undone!",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "Cancel",
        });
  
        if (!secondConfirmation.isConfirmed) {
          Swal.fire("Cancelled", "Action aborted.", "info");
          navigate("/dashboard");
        }
      } else {
        Swal.fire("Access Denied", "Only developers can access this section.", "error");
        navigate("/dashboard");
      }
    };
  
    showInitialConfirmations();
  
    return () => {
    };
  }, []);
 
  return (
    <div
      style={{
        // height: "100vh",
        display: "flex",
        flexDirection: "column",
        fontFamily: "monospace",
      }}
    >
      <div>
        <CodeMirror
          value={code}
          height="50vh"
          theme={materialDark}
          extensions={[json()]}
          onChange={(value) => setCode(value)}
        />
      </div>

      <div className="d-flex gap-2">
        <button className="run-btn" onClick={validateJSON}>
          Run
        </button>
        {isValid && (
          <button className="run-btn" onClick={handleSubmit}>
            Submit
          </button>
        )}
      </div>
      <pre
        style={{
          flexGrow: 1,
          background: "#f4f4f4",
          padding: "10px",
          overflow: "auto",
          whiteSpace: "pre-wrap",
        }}
      >
        {output}
      </pre>
    </div>
  );
};

export default CasetteUpload;
